import {WelcomeHeader} from "../components/Header/WelcomeHeader";
import {WelcomeSlider} from "../components/Slider/WelcomeSlider";
import "../assets/styles/pages/home.scss"
import {ResetPasswordForm} from "../components/Form/ResetPasswordForm";

export const ResetPassword = () => {
    return (
        <div>
            <WelcomeHeader />

            <div className="home grid-50">

                <WelcomeSlider />

                <ResetPasswordForm />

            </div>
        </div>
    )
}
